import React from "react";

const Outlet = (props) => {
  return (
    <>
      {props.children}
    </>
  );
}

export default Outlet;